import React, { useState, useEffect } from 'react';
import { bool, func, object, number, string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage, intlShape } from '../../../util/reactIntl';
import { ACCOUNT_SETTINGS_PAGES } from '../../../routing/routeConfiguration';
import { propTypes } from '../../../util/types';
import {
  Avatar,
  InlineTextButton,
  LinkedLogo,
  Menu,
  MenuLabel,
  MenuContent,
  MenuItem,
  NamedLink,
} from '../../../components';

import TopbarSearchForm from '../TopbarSearchForm/TopbarSearchForm';

import css from './TopbarDesktop.module.css';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const TopbarDesktop = props => {
  const {
    className,
    appConfig,
    currentUser,
    currentPage,
    rootClassName,
    currentUserHasListings,
    notificationCount,
    intl,
    isAuthenticated,
    onLogout,
    onSearchSubmit,
    initialSearchFormValues,
    formSearchPageMap,
    landingPage
    // isLandingPage = false,

  } = props;
  const location = useLocation();
  const {pathname} = location||{};
  const isHomePage=pathname=="/"
  console.log(formSearchPageMap,"---here")
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const marketplaceName = appConfig.marketplaceName;
  const authenticatedOnClientSide = mounted && isAuthenticated;
  const isAuthenticatedOrJustHydrated = isAuthenticated || !mounted;

  const classes = classNames(rootClassName || css.root, className);

  const search = !isHomePage ? (
    <TopbarSearchForm
      style={{ flex: 1, marginLeft: '32px', marginRight: '32px' }}
      className={css.searchLink}
      desktopInputRoot={css.topbarSearchWithLeftPadding}
      onSubmit={onSearchSubmit}
      initialValues={initialSearchFormValues}
      appConfig={appConfig}
      formSearchPageMap={formSearchPageMap}
    />
  ) : null;

  const notificationDot = notificationCount > 0 ? <div className={css.notificationDot} /> : null;

  const inboxLink = authenticatedOnClientSide ? (
    <NamedLink
      className={css.inboxLink}
      name="InboxPage"
      params={{ tab: currentUserHasListings ? 'sales' : 'orders' }}
    >
      <div className={css.inboxIcon}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path d="M0 64H512v80L256 320 0 144V64zM0 448V182.8L237.9 346.4 256 358.8l18.1-12.5L512 182.8V448H0z" />
        </svg>
      </div>
      {/* <span className={css.inbox}>
        <FormattedMessage id="TopbarDesktop.inbox" />
        {notificationDot}
      </span> */}
    </NamedLink>
  ) : null;

  const cartLink = authenticatedOnClientSide ? (
    <NamedLink className={css.cartLink} name="SearchPage">
      <div className={css.cartIcon}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
          <path d="M24 0H0V48H24 76.1l60.3 316.5 3.7 19.5H160 488h24V336H488 179.9l-9.1-48H496L576 32H122l-2.4-12.5L115.9 0H96 24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z" />
        </svg>
      </div>
    </NamedLink>
  ) : null;

  const favoritesLink = authenticatedOnClientSide ? (
    <NamedLink className={css.cartLink} name="FavListingsPage">
      <div className={css.cartIcon}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
</svg>

      </div>
    </NamedLink>
  ) : null;


  const currentPageClass = page => {
    const isAccountSettingsPage =
      page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
    return currentPage === page || isAccountSettingsPage ? css.currentPage : null;
  };
  const draftId = '00000000-0000-0000-0000-000000000000';
  const draftSlug = 'draft';
  const isOwner = currentUser?.id?.uuid === process.env.REACT_APP_OWNER_USER_ID;

  const profileMenu = authenticatedOnClientSide ? (
    <Menu>
      <MenuLabel className={css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
        <Avatar className={css.avatar} user={currentUser} disableProfileLink />
        {/* <div className={css.arrowIcon}>&#10140;</div> */}
      </MenuLabel>
      <MenuContent className={css.profileMenuContent}>
        <MenuItem key="ManageListingsPage">
          <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('ManageListingsPage'))}
            name="ManageListingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.yourListingsLink" />
          </NamedLink>
        </MenuItem>

        <MenuItem key="FollowersPage">
          <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('FollowersPage'))}
            name="FollowersPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.FollowersPage" />
          </NamedLink>
        </MenuItem>

        <MenuItem key="ProfileSettingsPage">
          <NamedLink
            className={classNames(css.profileSettingsLink, currentPageClass('ProfileSettingsPage'))}
            name="ProfileSettingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.profileSettingsLink" />
          </NamedLink>
        </MenuItem>
        <MenuItem key="AccountSettingsPage">
          <NamedLink
            className={classNames(css.yourListingsLink, currentPageClass('AccountSettingsPage'))}
            name="AccountSettingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.accountSettingsLink" />
          </NamedLink>
        </MenuItem>
        <MenuItem key="logout">
          <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.logout" />
          </InlineTextButton>
        </MenuItem>
      </MenuContent>
    </Menu>
  ) : null;

  const sellLink = authenticatedOnClientSide ? (
    <NamedLink className={css.createListingLink} name="NewListingPage">
      <span className={css.createListing}>
        <FormattedMessage id="TopbarDesktop.createListing" />
      </span>
    </NamedLink>
  ) : null;

  const gymLink =
  authenticatedOnClientSide && isOwner ? (
    <NamedLink
      className={css.createListingLink}
      to={{ state: { gymListing:true} }}
      name="EditListingPage"
      params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'details' }}
    >
      <span className={css.createListing}>
        <FormattedMessage id="TopbarDesktop.createListingGym" />
      </span>
    </NamedLink>
  ) : null;

  const signupLink = isAuthenticatedOrJustHydrated ? null : (
    <NamedLink name="SignupPage" className={css.navLink}>
      Sign up
    </NamedLink>
  );

  const loginLink = isAuthenticatedOrJustHydrated ? null : (
    <NamedLink name="LoginPage" className={css.primaryButton}>
      <span className={css.buttonText}>
        Sign in
      </span>
    </NamedLink>
  );
  const blogLink = (
    <NamedLink
      name="BlogPostsPage"
      className={css.navLink}
    >
      Blog
    </NamedLink>
  );

  return (
    <nav className={classes}>
      <div className={css.logoWrapper}>
        <img
          className={css.logo}
          alt="Grounddz MARTIALARTS"
          src="/static/img/grounddz-martialarts-no-strapline-1.png"
          onClick={() => window.location.href = '/'}
          style={{ cursor: 'pointer' }}
        />
      </div>
      
      {search}
      
      <div className={css.rightSection}>
        <div className={css.navLinks}>
          <NamedLink
            className={css.navLink}
            name="SearchPage"
            params={{ pub_listingType: 'product-selling' }}
          >
            Browse gear
          </NamedLink>
          <NamedLink
            className={css.navLink}
            name="SearchPageGym"
            to={{
              search: '?pub_listingType=gym',
            }}
          >
            Find gyms
          </NamedLink>
          <NamedLink
            className={css.navLink}
            name="NewListingPage"
          >
            Sell
          </NamedLink>
          {blogLink}
        </div>
        
        {authenticatedOnClientSide ? (
          <>
            {favoritesLink}
            {cartLink}
            {inboxLink}
            {profileMenu}
          </>
        ) : (
          <>
            {/* {signupLink} */}
            {loginLink}
          </>
        )}
      </div>
    </nav>
  );
};

TopbarDesktop.defaultProps = {
  rootClassName: null,
  className: null,
  currentUser: null,
  currentPage: null,
  notificationCount: 0,
  initialSearchFormValues: {},
  appConfig: null,
};

TopbarDesktop.propTypes = {
  rootClassName: string,
  className: string,
  currentUserHasListings: bool.isRequired,
  currentUser: propTypes.currentUser,
  currentPage: string,
  isAuthenticated: bool.isRequired,
  onLogout: func.isRequired,
  notificationCount: number,
  onSearchSubmit: func.isRequired,
  initialSearchFormValues: object,
  intl: intlShape.isRequired,
  appConfig: object,
};

export default TopbarDesktop;
